import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, TipoUnidad, SaveTipoUnidadDto, SearchTipoUnidadRequest } from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})
export class TipoUnidadService extends CrudService<TipoUnidad, number, SaveTipoUnidadDto, SearchTipoUnidadRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'tipoUnidad', sharedFunctions);

  }
}